var _defs, _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLinkLNv(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 24,
    viewBox: "0 0 16 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;opacity:0;}.b{fill:#002445;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 16,
    height: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,9.987a1.5,1.5,0,0,1-1.5-1.5L-1.5,0A1.5,1.5,0,0,1,0-1.5,1.5,1.5,0,0,1,1.5,0l0,8.487A1.5,1.5,0,0,1,0,9.987Z",
    transform: "translate(5 12.003) rotate(-135)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.487,1.5h0L0,1.5A1.5,1.5,0,0,1-1.5,0,1.5,1.5,0,0,1,0-1.5l8.487,0A1.5,1.5,0,0,1,9.987,0,1.5,1.5,0,0,1,8.487,1.5Z",
    transform: "translate(11 18) rotate(-135)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkLNv);
export default __webpack_public_path__ + "static/media/icon_link_l_nv.2e65a5acd801534e15f1bb3d516c0c15.svg";
export { ForwardRef as ReactComponent };